import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { useRoute } from "vue-router";
	import { computed } from "vue";

	
export default /*@__PURE__*/_defineComponent({
  __name: 'DevicesPage',
  setup(__props) {

	const route = useRoute();
	const routeKey = computed(() => String(route.name) + "-" + (route.params.deviceId ?? "new"));

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { key: routeKey.value }))
    ]),
    _: 1
  }))
}
}

})